import { home_data } from 'src/stores/account/user';
import { scenes } from 'src/stores/lists/scenes';

import { save_home, delete_home } from 'src/helpers/home_helpers';
import type { ISceneObj } from 'src/types/SceneType';
import { get } from 'svelte/store';

// Check if the scene is part of the Earth Day 2025 and
export function isEarthDayScene(scene_id: string) {
	const campaignScene = Object.values(get(scenes)).find(
		(scene: ISceneObj) =>
			scene._meta.hasOwnProperty('extra') && scene._meta.extra === 'EearthDay2025',
	) as ISceneObj;

	if (!campaignScene) return false;

	return scene_id == campaignScene._id;
}

export function disableEarthDaySceneCreated(scene_id: string) {
	if (!isEarthDayScene(scene_id)) return false;

	if (get(home_data)?.earthDaySceneCreated) {
		delete_home('earthDaySceneCreated');
	}
}
